import { SLIDER_ANIMATION_DURATION  } from "../private/config/config";

const Slider = {
  namespaced: true,

  state: {
    //Открыт ли слайдер?
    isOpen: false,
    //Массив с объектами слайдов
    slides: [],
    //Индекс слайда, с которого стоит начать показ
    startIndex: 0,    
  },

  actions: {
    //Активировать слайдер
    activeSlider({ commit }, { data, index }){
      commit('TOGGLE_VISIBLE_MODE_SLIDE', true);
      commit('WRITE_SLIDES', data);
      commit('CHOOSE_SLIDE', index);
    },

    //Закрыть слайдер
    closeSlider({ commit }){
      commit('TOGGLE_VISIBLE_MODE_SLIDE', false);
      setTimeout(() => commit('RESET_SLIDER'), SLIDER_ANIMATION_DURATION);
    },
  },

  mutations: {
    //Отобразить/Скрыть слайдер
    TOGGLE_VISIBLE_MODE_SLIDE(state, status){ state.isOpen = status; },
    
    //Отобразить слайд, от которого начнется просмотр
    CHOOSE_SLIDE(state, index){ 
      if (index >= 0 && index < state.slides.length) {
        state.startIndex = index;
      }
    },

    //Записть данные для слайдера
    WRITE_SLIDES(state, data){
      state.slides = Array.isArray(data) ? [...data] : []; 
    },

    //Сброс состояния слайдера
    RESET_SLIDER(state) {
      state.slides = [];
      state.startIndex = 0;
    }
  },
}

export default Slider;